import ContestsEditor from './ContestsEditor';
import { Header } from '../../components';
import ormActions from '../../orm/actions';
import {
  gendersSelector,
  bodyweightCategoriesSelector,
  ageGroupsSelector,
  contestsSelector,
} from '../../orm/selectors';
import { bickActions } from '../../common';

import React from 'react';
import { connect } from 'react-redux';

const Contests = ({ bodyweightCategories, ageGroups, contests, actions }) => (
  <section>
    <Header as="h1">Contests</Header>
    <ContestsEditor
      id="setup--contests-editor"
      contests={contests}
      meta={{ bodyweightCategories, ageGroups }}
      actions={actions.contest}
    />
  </section>
);

const mapStateToProps = ({ orm }) => ({
  genders: gendersSelector(orm),
  ageGroups: ageGroupsSelector(orm),
  bodyweightCategories: bodyweightCategoriesSelector(orm),
  contests: contestsSelector(orm),
});

const mapDispatchToProps = dispatch => ({
  actions: bickActions(ormActions, ['contest'], dispatch),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Contests);



// WEBPACK FOOTER //
// ./src/pages/Setup/Contests.js